import pluralize from "pluralize";
import React from "react";
import { VariantGroup } from "types";
import { PromptModal } from "@/components/Common/PromptModal";

interface DeleteVariantGroupModalProps {
    isOpen: boolean;
    group: VariantGroup | undefined;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteVariantGroupModal = ({ isOpen, group, onClose, onConfirm }: DeleteVariantGroupModalProps) => {
    if (!isOpen || !group) {
        return null;
    }

    const optionCount = group.options.length;

    return (
        <PromptModal
            isOpen={isOpen}
            title="Delete Variant Group?"
            color="danger"
            dialogText={{ secondary: "Cancel", submit: "Delete" }}
            onClose={onClose}
            onConfirm={onConfirm}
        >
            <div className="space-y-4 break-all text-center">
                <p>
                    Are you sure you want to delete the &ldquo;{group.name}&rdquo; variant group? The {optionCount}{" "}
                    {pluralize("variant option", optionCount)} it contains will also be deleted.
                </p>
                <p>This action cannot be un-done. Any existing inventory will be removed.</p>
            </div>
        </PromptModal>
    );
};
